import React, { useMemo } from 'react';
import styles from './Button.module.scss';
import classnames from 'classnames';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { GlobalIcon } from '../..';

export interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  type?: 'primary' | 'secondary' | 'white';
  widthType?: 'fullWidth' | 'halfWidth' | 'fluid' | 'padded';
  labelSize?: 'normal' | 'small';
  href?: string;
  as?: string;
  target?: string;
  rel?: string;
  htmlType?: 'submit' | 'reset' | 'button';
  rightIconImage?: any;
}

export const Button = ({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onClick = () => {},
  type = 'primary',
  widthType = 'halfWidth',
  labelSize = 'normal',
  className,
  children,
  href,
  as,
  target,
  rel,
  htmlType = 'button',
  rightIconImage,
}: ButtonProps) => {
  const { locale } = useRouter();
  const label = useMemo(() => {
    if (href) {
      const linkProps = { href, as, locale: locale };
      const aProps = { rel, target };

      return (
        <Link {...linkProps}>
          <a className={styles.label} {...aProps}>
            {children}
          </a>
        </Link>
      );
    }

    return <span className={styles.label}>{children}</span>;
  }, [as, children, href, rel, target, locale]);

  return (
    <button
      type={htmlType}
      className={classnames(
        styles.button,
        styles[type] || styles.primary,
        styles[widthType],
        className
      )}
      onClick={onClick}>
      <span className={classnames(styles.label, styles[labelSize])}>{label}</span>
      {rightIconImage && <GlobalIcon image={rightIconImage} className={styles.rightIcon} />}
    </button>
  );
};

export default Button;
